import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { COLORS } from '@btime/constants'
import Center from '../../../../packages/kiti/components/helpers/Center'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import ShareLink from '../../../../components/presentation/ShareLink'
import Text, { Title } from '../../../../packages/kiti/components/presentation/Text'
import { HorizontalLine } from '../../../../components/shapes/Line'
import { useLocation } from '../../../../utils/contexts/UrlProvider'
import { useShareDynamicServiceOrder } from './_context/ShareDynamicServiceOrderContext'

const ShareDynamicServiceOrderForm = () => {
  const { t } = useTranslation('shareDynamicServiceOrders')
  const form = useShareDynamicServiceOrder()
  const { host } = useLocation()
  const shareLink = `${host}/m/dynamic-service-orders/${form.shareCode}/execution`

  return (
    <Fragment>
      <Title size="h4" align="center">
        {form.name}
      </Title>
      <Center>
        <Text align="center" maxWidth={16}>
          {t('publicSubtitle')}
        </Text>
      </Center>
      <Separator weight={6} />
      <HorizontalLine thin lineColor={COLORS.light3} />
      <Separator weight={6} />
      <ShareLink label={t('shareLink')} url={shareLink} />
    </Fragment>
  )
}

export default ShareDynamicServiceOrderForm
